import { useEffect, useRef, useState } from 'react';

import Modal from '~/components/modals/modal';
import { widgetTypes } from '~/components/products/yotpo-product-reviews-widget';
import SmartLawnPlanReviewsV2 from '~/components/static/reviews/smart-lawn-plan-reviews-v2';
import BackToTopPill from '~/components/back-to-top-pill/back-to-top-pill';

import styles from '~/components/modals/modal.module.scss';

const LawnPlanReviewsModal = ({ onClose, isOpen }) => {
  const [isPillVisible, setIsPillVisible] = useState(false);
  const scrollElRef = useRef(null);

  return (
    <Modal onClose={onClose} isOpen={isOpen} className={styles.extraWide}>
      {isPillVisible && <BackToTopPill scrollElRef={scrollElRef.current} />}
      <Content
        isOpen={isOpen}
        scrollElRef={scrollElRef}
        setIsPillVisible={setIsPillVisible}
      />
    </Modal>
  );
};

const Content = ({ isOpen, setIsPillVisible, scrollElRef }) => {
  useEffect(() => {
    if (isOpen) {
      window.yotpoWidgetsContainer?.initWidgets();
    }
  }, [isOpen]);

  // Logic for <BackToTopPill /> must live on parent
  useEffect(() => {
    const scrollEl = document.querySelector('[class*="extraWide"]');
    scrollElRef.current = scrollEl;

    const handleScroll = () => {
      const screenHeight = scrollEl.clientHeight;
      const scrollTop = scrollEl.scrollTop;

      if (scrollTop > screenHeight) {
        setIsPillVisible(true);
      } else setIsPillVisible(false);
    };

    scrollEl.addEventListener('scroll', handleScroll);
    return () => scrollEl.removeEventListener('scroll', handleScroll);
  }, [scrollElRef, setIsPillVisible]);

  return (
    <>
      <h2 style={{ marginBottom: '0' }}>Real people, real results</h2>
      <SmartLawnPlanReviewsV2 widget={widgetTypes.MAIN} />
    </>
  );
};

export default LawnPlanReviewsModal;
